import { Injectable } from '@angular/core';

import { LinkTarget } from '../constants/link-target.enum';
import { ContextService } from '../shared-context/context.service';
import { LaunchAction, UrlLauncherService } from './url-launcher.service';
import { WindowService } from './window.service';

@Injectable({
    providedIn: 'root'
})
export class WindowUrlLauncherService implements UrlLauncherService {

    constructor(
        private readonly contextService: ContextService,
        private readonly windowService: WindowService
    ) {
    }

    public async openUrl(webUrl: string, _action: LaunchAction, linkTarget?: LinkTarget, width?: number, height?: number): Promise<void> {
        const frameSize = typeof width === 'number' && typeof height === 'number' ? `width=${width},height=${height}` : '';
        this.windowService.nativeWindow.open(webUrl, linkTarget || this.contextService.sharedContext.defaultLinkTarget, frameSize);
        return Promise.resolve();
    }

    public supportsProtocol(_protocol: string): Promise<boolean> {
        return Promise.reject('Method not implemented.');
    }
}
